import { useRouter } from 'next/router'

export const ThemesPriceFilter = () => {
	const { query, push } = useRouter()

	const price = query.price as string | undefined

	const handleOnChange = (priceOption: string) => {
		push({ query: { price: priceOption === 'all' ? [] : 0 } }, undefined, {
			shallow: true
		})
	}

	return (
		<>
			<label key={`All Prices`} className="flex items-center my-2 cursor-pointer">
				<input
					type="radio"
					name="type"
					className="radioInput"
					value={'all'}
					onChange={() => handleOnChange('all')}
					checked={!price}
				/>
				All
			</label>
			<label key={`Free`} className="flex items-center my-2 cursor-pointer">
				<input
					type="radio"
					name="type"
					className="radioInput"
					value={'free'}
					onChange={() => handleOnChange('free')}
					checked={price === '0'}
				/>
				Free
			</label>
		</>
	)
}
